import { c as _c } from "react/compiler-runtime";
import type { RichTable } from "@/sanity/sanity.types";
import RichTableCell from "./rich-table-cell";
const headerCellClassName = "border border-gray-300 bg-gray-100 p-3 text-left font-semibold text-[#0074a6]";
const bodyCellClassName = "border border-gray-300 p-3 align-top text-[16px] text-[#373a36]";
export interface IRichTableRendererProps {
  value: RichTable;
}
const RichTableRenderer = t0 => {
  const $ = _c(24);
  const {
    value
  } = t0;
  let firstColumnIsHeader;
  let firstRowIsHeader;
  let rows;
  let t1;
  let t2;
  if ($[0] !== value?.firstColumnIsHeader || $[1] !== value?.firstRowIsHeader || $[2] !== value?.rows) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      rows = value?.rows || [];
      if (!rows.length) {
        t2 = null;
        break bb0;
      }
      firstRowIsHeader = value?.firstRowIsHeader !== false;
      firstColumnIsHeader = value?.firstColumnIsHeader === true;
      const columnCount = rows.reduce(_temp, 0);
      t1 = Array.from({
        length: columnCount
      }, _temp2);
    }
    $[0] = value?.firstColumnIsHeader;
    $[1] = value?.firstRowIsHeader;
    $[2] = value?.rows;
    $[3] = firstColumnIsHeader;
    $[4] = firstRowIsHeader;
    $[5] = rows;
    $[6] = t1;
    $[7] = t2;
  } else {
    firstColumnIsHeader = $[3];
    firstRowIsHeader = $[4];
    rows = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const columns = t1;
  const headerRow = firstRowIsHeader ? rows[0] : null;
  let t3;
  if ($[8] !== firstRowIsHeader || $[9] !== rows) {
    t3 = firstRowIsHeader ? rows.slice(1) : rows;
    $[8] = firstRowIsHeader;
    $[9] = rows;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const bodyRows = t3;
  let t4;
  if ($[11] !== value) {
    t4 = value?.caption && <caption className="caption-bottom pt-2 text-left text-[14px] text-[#373a36]">{value.caption}</caption>;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== columns || $[14] !== headerRow) {
    t5 = headerRow && <thead><tr>{columns.map(columnIndex => <th key={headerRow.cells?.[columnIndex]?._key ?? columnIndex} scope="col" className={headerCellClassName}><RichTableCell cell={headerRow.cells?.[columnIndex]} /></th>)}</tr></thead>;
    $[13] = columns;
    $[14] = headerRow;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== bodyRows || $[17] !== columns || $[18] !== firstColumnIsHeader) {
    t6 = !!bodyRows.length && <tbody>{bodyRows.map((row_0, rowIndex) => <tr key={row_0?._key ?? rowIndex}>{columns.map(columnIndex_0 => {
          const cell = row_0?.cells?.[columnIndex_0];
          const key = cell?._key ?? columnIndex_0;
          if (firstColumnIsHeader && columnIndex_0 === 0) {
            return <th key={key} scope="row" className={headerCellClassName}><RichTableCell cell={cell} /></th>;
          }
          return <td key={key} className={bodyCellClassName}><RichTableCell cell={cell} /></td>;
        })}</tr>)}</tbody>;
    $[16] = bodyRows;
    $[17] = columns;
    $[18] = firstColumnIsHeader;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <table className="my-6 w-full border-collapse border border-gray-300">{t4}{t5}{t6}</table>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default RichTableRenderer;
function _temp(max, row) {
  return Math.max(max, row?.cells?.length || 0);
}
function _temp2(_, index) {
  return index;
}